import { render, staticRenderFns } from "./SubmitFlow.vue?vue&type=template&id=77797c87&scoped=true&"
import script from "./SubmitFlow.vue?vue&type=script&lang=ts&"
export * from "./SubmitFlow.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitFlow.vue?vue&type=style&index=0&id=77797c87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77797c87",
  null
  
)

export default component.exports